import $ from "jquery";
window.$ = $;
window.jQuery = $;
import 'bootstrap';
import 'bootstrap-select';
require("./jquery.tablesorter.min");
require("../../../node_modules/fancybox/dist/js/jquery.fancybox.js");
require("../../../node_modules/slick-carousel/slick/slick.js");
import Noty from 'noty';

require("./news");
require("./trombino");
require("./data");
require("./liste-membre");
require("./agenda");
require("./search");

$(document).ready(function() {
    if ($(".prepub-container").length) {
        new Noty({
            text: 'Vous êtes sur un contenu de prépublication. <br/> Pour revenir à la production <a href="/prepub/unview">cliquez ici</a>',
            layout: 'bottomLeft',
            theme: 'bootstrap-v4',
            type: 'info'
        }).show();
    }

    /*$("body").on("click", ".navbar-menu", function(){
        if($("body").hasClass("menu-opened")){
            $("body").removeClass("menu-opened");
        } else {
            $("body").addClass("menu-opened");
        }
    });*/

    $("body").on("click", ".btn-search", function(){
        if($("body").hasClass("search-opened")){
            $("body").removeClass("search-opened");
        } else {
            $("body").addClass("search-opened");
        }
    });

    $("body").on("click", function(event){
        var clickover = $(event.target);
        var _opened = $(".wrapper-search").hasClass("show");
       
        if (_opened === true && !clickover.hasClass("btn-search") && clickover.closest(".wrapper-search .search-form").length == 0) {
            $(".btn-search").click();
        }
    });

    /* show scrollTop button on scroll */
    $(window).off().scroll(function() {
        if ($(window).scrollTop() >= 100) {
            $(".wrapper-scroll-top").removeClass('hidden');
        }else{
            $(".wrapper-scroll-top").addClass('hidden');
        }
    });

    /* scrollTop */
    $('body').on('click','.scroll-top', function(){
        $("html, body").animate({ scrollTop: 0 }, 500);
    });

    /**** hauteur max automatique ****/
    function maxHeight(list, el, get){
        var maxHeight = -1;
        list.find(el).each(function() {
          if(!get){
            $(this).css("height","auto");
          }
          maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });
        if(get){
          return maxHeight;
        }
        list.find(el).height(maxHeight);
    }
      
    /*** mettre des blocs en même hauteur ***/
    $(window).on("resize", function() {
        $(".auto-height:visible").each(function(){
            var list = $(this);
            var elements = $(this).data("height-ref").split(",");
            for(var i=0;i<elements.length;i++){
                maxHeight(list, elements[i]);
            }
        });
    }).trigger("resize");

    $(window).on('load').trigger("resize");

    /* custom select */
    $(".selectpicker").selectpicker();
    $(".bootstrap-select").on("click", function(event) {
        var target = $(event.target);
        if (target.parents(".dropdown-menu").length) {
            $(".bootstrap-select.show").removeClass("show, dropup").find(">.dropdown-menu").removeClass("show");
        }
    });

    $("body").on("click", function(event){
        if($("body").find(".collapse.show").length && !$(event.target).parents(".collapse.show").length && !$(event.target).hasClass("btn-collapse")){
            $("body").find(".btn-collapse[aria-expanded='true']").click();

        }
    });

    // ScrollTo anchor
    $(".anchor-link").click(function(){
        $(".anchor-link").removeClass("active");
        $(this).addClass("active");
        $("html, body").stop().animate({
            scrollTop: $($(this).attr("href")).offset().top
        }, 400);
        return false;
    });

    // chart podium
    $(".list-chart").each( function(){ 
        var maximum = null;
        
        $(this).find('.value-bar').each(function() {
            var value = parseInt($(this).text().replace(/\s/g, ''));
            maximum = (value > maximum) ? value : maximum;
        });
        
        $(this).find('.pourcent-bar').each(function() {
            var value = $(this).parents(".bar").find(".value-bar").text().replace(/\s/g, '');
            $(this).css({"width": value/maximum*(85)+"%"});
        });
        
    });

    $(".fancybox").fancybox();

    // link ligne table
    $("table.table-marque").on("click", "tbody tr[data-href]", function(){
        window.location.href = $(this).data("href");
    });

    /* Menu on mobile */
    if ($(document).width() < 1025){
        const toggleMenuMobile = $('.header .menu-principal .navbar-nav .nav-item .dropdown-menu .dropdown-item .dropdown-toggle');
        $(toggleMenuMobile).on('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            $('.dropdown-menu.show, .dropdown-toggle.show', $(this).parent().siblings()).removeClass('show');

            if ($(this).hasClass('show')) {
                $(this).removeClass('show');
                $(this).siblings('.dropdown-menu.show').removeClass('show');
            }
            else {
                $(this).addClass('show');
                $(this).siblings('.dropdown-menu').addClass('show');
            }
        });
    }

    $('#show-menu').click(function() {
        if ($('#slide-out').hasClass('visible')) {
            $('#slide-out').toggleClass('close');
        } else {
            $('#slide-out').addClass('visible');
        }

        let open = !$('#slide-out').hasClass('close');
        $('body').removeClass('menu-opened');
        if (open) {
            $('body').addClass('menu-opened');
        }
    });

    $('#hide-menu').click(function() {
        $('#slide-out').addClass('close');
        $('body').removeClass('menu-opened');
    });

    /* Footer menu mobile */
    if ($(document).width() < 1025){
        $('.footer-menu-ul').addClass('collapse');
    }

    $('.wrapper-description .collapse').on('shown.bs.collapse', function() {
        $(this).parent().find(".btn-see-more .label").html("Voir moins");
    }).on('hidden.bs.collapse', function() {
        $(this).parent().find(".btn-see-more .label").html("Voir plus");
    });

    if ($(".accept-cookie").length) {
        var name = "accept_cookie=";
        var ca = document.cookie.split(';');
        var cookieValue = "";
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                cookieValue = c.substring(name.length, c.length);
            }
        }

        if (cookieValue == "" || cookieValue == 0) {
            $("#cookie-sticky").show();
        }

        $(".accept-cookie, .cookie-close").click(function(e) {
            e.preventDefault();
            var d = new Date();
            d.setTime(d.getTime() + (365*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = "accept_cookie=1;" + expires + ";path=/";

            $("#cookie-sticky").hide();
        });
    }

    $("body").on("click", ".all-news", function() {
        var isChecked = $(this).is(":checked");

        $(".news").each(function() {
            if (isChecked) {
                $(this).prop("checked", true);
            } else {
                $(this).prop("checked", false);
            }
        });
    });

    $('.carousel-agenda').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 1340,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    /* Table header scroll on classement pages */
    function AncorControlMatches() {
        if ($('.table-scroll').length) {
            let topPos = $('.table-scroll').offset().top,
            pos = $(document).scrollTop(),
            total = pos - topPos;
            if (pos > topPos) {
                $('.table-scroll thead tr').css('top', total).addClass('scroll');
            } else {
                $('.table-scroll thead tr').removeClass('scroll');
            }
        }
    }

    $(window).scroll(function () {
        AncorControlMatches();
    });

    /* To print page */
    $('.js-btn-print').on('click', function () {
        window.print();
    })

    /* inscription communique */
    let register_cookie = getCookie('register_modal');


    if (register_cookie === null) {

      let rgpd_cookie = getCookie('tarteaucitron');
      if (rgpd_cookie !== null){
        if (rgpd_cookie.indexOf("wait") !== -1) {
          setTimeout(function() { open_register_modal(); }, 5000);
        }else{
          open_register_modal();
        }
      }else{
        setTimeout(function() { open_register_modal(); }, 5000);
      }
      
      
    }

});

function open_register_modal(){
  $('#inscriptionModal').modal();
  setCookie('register_modal','true',15);
}

// Set a Cookie
function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return null;
}
